import React from "react";
import { Languages } from "lucide-react";
import { getLang, setLangPref } from "@/lib/i18n";

/** EN/ES switch — reloads so the whole app re-renders in the new language. */
export default function LangToggle({ className = "" }) {
  const lang = getLang();
  const next = lang === "es" ? "en" : "es";
  return (
    <button
      type="button"
      onClick={() => { setLangPref(next); window.location.reload(); }}
      className={`h-9 px-2.5 inline-flex items-center gap-1.5 rounded-sm border border-border text-xs font-semibold text-muted-foreground hover:text-foreground transition-colors ${className}`}
      title={lang === "es" ? "Cambiar a inglés" : "Switch to Spanish"}
      data-testid="lang-toggle"
    >
      <Languages className="w-4 h-4" />
      {lang === "es" ? "EN" : "ES"}
    </button>
  );
}
